import { Box, SxProps } from '@mui/material';
import { FC } from 'react';
import BookRefinementList from '@components/Books/BookRefinementList';
import { BookRefinementListProps } from '@models/books';

const filterContainerSx: SxProps = {
    bgcolor: 'grey.600',
    borderRadius: 1,
    display: 'grid',
    gap: 2,
    gridTemplateColumns: '1fr 1fr',
    maxWidth: 'md',
    mb: 6,
    mt: -6,
    mx: 'auto',
    p: 2,
    width: '100%',
};

interface FilterProps {
    languages: BookRefinementListProps;
    lawScopes: BookRefinementListProps;
}

const FilterGroups: FC<FilterProps> = ({ languages, lawScopes }) => {
    return (
        <Box sx={filterContainerSx}>
            <BookRefinementList {...lawScopes} />
            <BookRefinementList {...languages} />
        </Box>
    );
};
export default FilterGroups;
